import React from 'react';
import { ReactComponent as TopScoresIcon } from '../assets/podium.svg';

export default function TopScores() {
  return (
    <div className='header__top-scores'>
      <TopScoresIcon />
    </div>
  );
}
